import HttpClient from './http-clients/portaljad'

const baseUrl = 'empresa'

export default class EmpresaService {
  static async findLinks() {
    try {
      const { data } = await HttpClient.get([baseUrl, 'links-clientes'].join('/'))
      return data.body
    } catch (error) {
      throw error.response.data
    }
  }

  static async authCustomToken(request, token) {
    try {
      const { data } = await HttpClient.put([baseUrl, 'auth', 'custom-token', token].join('/'), request)
      return data.body
    } catch (error) {
      throw error.response
    }
  }
}
